// useGlossary — session-level in-memory cache + fetch composable.
// Terms fetched from DB (via /api/glossary/enrich) are stored here so repeated
// occurrences of the same term across multiple messages don't re-hit the server.

const sessionCache = new Map() // term (normalized) -> { definition, example, category }

async function enrich(text) {
  if (!text || typeof text !== 'string' || text.length < 10) return {}

  try {
    const res = await fetch('/api/glossary/enrich', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text }),
    })
    if (!res.ok) return {}

    const data = await res.json()
    if (!data.success || !data.glossary) return {}

    for (const [term, info] of Object.entries(data.glossary)) {
      sessionCache.set(term, info)
    }

    return data.glossary
  } catch {
    return {}
  }
}

function getFromCache(term) {
  return sessionCache.get(term) || null
}

function clearCache() {
  sessionCache.clear()
}

export function useGlossary() {
  return { enrich, getFromCache, clearCache, sessionCache }
}
